import Vue from "vue";
import TaskStatus from "@tt/vue-tasks";
import store from "@/store";

Vue.use(TaskStatus, { store });
